import { render, staticRenderFns } from "./indexcenter.vue?vue&type=template&id=f9319fa2&"
import script from "./indexcenter.vue?vue&type=script&lang=js&"
export * from "./indexcenter.vue?vue&type=script&lang=js&"
import style0 from "./indexcenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports